export enum BrowserType {
  Firefox = 'firefox',
}

export const isFirefox = () => {
  const { userAgent } = window.navigator
  return userAgent.toLowerCase().includes(BrowserType.Firefox)
}
